module.exports = new __parcel__URL__("AudioBriefingChangeboardingIllustration.42aee684.svg").toString();